export const NAME = 'name'
export const DISCOUNTS = 'discounts'
export const QUANTITY = 'quantity'
export const PERIODS = 'periods'
export const DISCOUNT_PERCENTAGE = 'discount_percentage'
